import { render, staticRenderFns } from "./AIFailureHelp.vue?vue&type=template&id=3c5870c0&"
import script from "./AIFailureHelp.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AIFailureHelp.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports